import "./style/index.scss";
import { CheckCircleOutlined, CheckOutlined, CloseOutlined, WarningOutlined } from "@ant-design/icons";
import { Form, Space, Button, Col, Row, Divider, Input, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { atualizarGradePremiacao, cadastrarGradePremiacao } from "../../../../services/gradePremiacaoService";
import { realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { toastError } from "../../../../util/toast";
import { setModalCadastrarGradePremiacao } from "../../../../redux/slices/gradePremiacao/gradePremiacaoSlice";

const CadastroGradePremiacao = () => {
  //estados globais
  const gradePremiacaoState = useAppSelector((state) => state.gradePremiacao);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<any>();
  const [totalValor, setTotalValor] = useState<number>(0);
  const [totalFatorTitulo, setTotalFatorTitulo] = useState<number>(0);

  const editar = Object.values(gradePremiacaoState.entity).length !== 0;

  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      form.setFieldsValue({ ...gradePremiacaoState.entity });
      handleCalculoValorTotal();
      handleCalculoFatorTitulo();
    } else {
      form.setFieldsValue({
        valorPremio1: 0,
        valorPremio2: 0,
        valorPremio3: 0,
        valorPremio4: 0,
        valorPremio5: 0,
        valorRodada: 0,
        valorTotalPremiacaoLiquido: 0,
        valorTotalPremiacaoBruto: 0,
        fatorPremiacao: 0,
        valorTitulo: 0,
        totalFatorTitulo: 0,
      });
    }
  }, [gradePremiacaoState.entity]);

  const submit = (values: any) => {
    if (Math.abs(Math.abs(totalValor) - Math.abs(totalFatorTitulo)) <= 0.01) {
      if (editar) {
        values.id = gradePremiacaoState.entity.id;
        dispatch(atualizarGradePremiacao({ value: values, busca: gradePremiacaoState.busca }));
      } else {
        dispatch(cadastrarGradePremiacao({ value: values, busca: gradePremiacaoState.busca }));
      }
    } else {
      toastError("O valor da premiação bruta difere do fator x título");
    }
  };

  const handleCalculoValorTotal = () => {
    form.setFieldValue(
      "valorTotalPremiacaoLiquido",
      form.getFieldValue("valorPremio1") +
        form.getFieldValue("valorPremio2") +
        form.getFieldValue("valorPremio3") +
        form.getFieldValue("valorPremio4") +
        form.getFieldValue("valorPremio5") +
        form.getFieldValue("valorRodada")
    );
    form.setFieldValue("valorTotalPremiacaoBruto", Math.trunc((form.getFieldValue("valorTotalPremiacaoLiquido") / 0.75) * 100) / 100);
    setTotalValor(form.getFieldValue("valorTotalPremiacaoBruto"));
  };

  const handleCalculoFatorTitulo = () => {
    form.setFieldValue("totalFatorTitulo", form.getFieldValue("fatorPremiacao") * form.getFieldValue("valorTitulo"));
    setTotalFatorTitulo(form.getFieldValue("totalFatorTitulo"));
  };

  const voltar = () => {
    dispatch(setModalCadastrarGradePremiacao(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            label="Denominação"
            name="denominacao"
            rules={[
              {
                required: true,
                message: "Digite a denominação",
              },
            ]}
          >
            <Input type="text" ref={inputInicial} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Fator premiação"
            name="fatorPremiacao"
            rules={[
              {
                required: true,
                message: "Digite o fator premiação",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={5}
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("fatorPremiacao", realParaNumber(form.getFieldValue("fatorPremiacao")));
                  handleCalculoFatorTitulo();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label="Valor título (R$)"
            name="valorTitulo"
            rules={[
              {
                required: true,
                message: "Digite o valor do título",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorTitulo", realParaNumber(form.getFieldValue("valorTitulo")));
                  handleCalculoFatorTitulo();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={
              <>
                <span style={{ marginRight: "3px" }}>Fator x Título</span>
                {!(Math.abs(Math.abs(totalValor) - Math.abs(totalFatorTitulo)) <= 0.01) ? (
                  <>
                    <Tooltip title="O valor da premiação bruta difere do fator x título">
                      <WarningOutlined style={{ color: "#FF0000" }} />
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <CheckCircleOutlined style={{ color: "#008000", marginLeft: "3px" }} />
                  </>
                )}
              </>
            }
            name="totalFatorTitulo"
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              disabled
              fixedDecimalScale={true}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={6}>
          <Form.Item
            label="1º Prêmio"
            name="valorPremio1"
            rules={[
              {
                required: true,
                message: "Digite o valor do prêmio 1",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorPremio1", realParaNumber(form.getFieldValue("valorPremio1")));
                  handleCalculoValorTotal();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="2º Prêmio"
            name="valorPremio2"
            rules={[
              {
                required: true,
                message: "Digite o valor do prêmio 2",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorPremio2", realParaNumber(form.getFieldValue("valorPremio2")));
                  handleCalculoValorTotal();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="3º Prêmio"
            name="valorPremio3"
            rules={[
              {
                required: true,
                message: "Digite o valor do prêmio 3",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorPremio3", realParaNumber(form.getFieldValue("valorPremio3")));
                  handleCalculoValorTotal();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="4º Prêmio"
            name="valorPremio4"
            rules={[
              {
                required: true,
                message: "Digite o valor do prêmio 4",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorPremio4", realParaNumber(form.getFieldValue("valorPremio4")));
                  handleCalculoValorTotal();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={6}>
          <Form.Item
            label="5º Prêmio"
            name="valorPremio5"
            rules={[
              {
                required: true,
                message: "Digite o valor do prêmio 5",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorPremio5", realParaNumber(form.getFieldValue("valorPremio5")));
                  handleCalculoValorTotal();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Rodada"
            name="valorRodada"
            rules={[
              {
                required: true,
                message: "Digite o valor da rodada",
              },
            ]}
            className="rodada"
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onValueChange={() =>
                setTimeout(() => {
                  form.setFieldValue("valorRodada", realParaNumber(form.getFieldValue("valorRodada")));
                  handleCalculoValorTotal();
                }, 700)
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Premiação Líquida"
            name="valorTotalPremiacaoLiquido"
            rules={[
              {
                required: true,
                message: "Digite o total liquido",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onChange={() => form.setFieldValue("valorTotalPremiacaoLiquido", realParaNumber(form.getFieldValue("valorTotalPremiacaoLiquido")))}
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={
              <>
                <span style={{ marginRight: "3px" }}>Premiação Bruta</span>
                {!(Math.abs(Math.abs(totalValor) - Math.abs(totalFatorTitulo)) <= 0.01) ? (
                  <>
                    <Tooltip title="O valor da premiação bruta difere do fator x título">
                      <WarningOutlined style={{ color: "#FF0000" }} />
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <CheckCircleOutlined style={{ color: "#008000", marginLeft: "3px" }} />
                  </>
                )}
              </>
            }
            name="valorTotalPremiacaoBruto"
            rules={[
              {
                required: true,
                message: "Digite o total bruto",
              },
            ]}
            className="bruto"
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              style={{ width: "100%" }}
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              disabled
              onChange={() => form.setFieldValue("valorTotalPremiacaoBruto", realParaNumber(form.getFieldValue("valorTotalPremiacaoBruto")))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <div className="modalFooter">
        <Space size="large" direction="horizontal" align="end">
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            {editar ? "ATUALIZAR" : "SALVAR"}
          </Button>
        </Space>
      </div>
    </Form>
  );
};

export default CadastroGradePremiacao;
